import { useEffect, useState } from "react";
import { X, PartyPopper } from "lucide-react";

/**
 * One-shot banner shown after a customer activates their account.
 * Reads `jdsn_welcome_message` + `jdsn_activate_promo` from sessionStorage and
 * clears them on dismiss (or on user navigation away from /dashboard).
 */
export default function WelcomeBanner() {
  const [msg, setMsg] = useState("");
  const [promo, setPromo] = useState("");

  useEffect(() => {
    try {
      const m = sessionStorage.getItem("jdsn_welcome_message");
      const p = sessionStorage.getItem("jdsn_activate_promo");
      if (m) setMsg(m);
      if (p) setPromo(p);
    } catch { /* noop */ }
  }, []);

  const close = () => {
    try {
      sessionStorage.removeItem("jdsn_welcome_message");
      sessionStorage.removeItem("jdsn_activate_promo");
    } catch { /* noop */ }
    setMsg("");
  };

  if (!msg) return null;
  return (
    <div className="bg-gradient-to-br from-[#062818] via-[#047857] to-[#059669] text-white rounded-3xl px-5 py-5 sm:px-7 sm:py-6 relative overflow-hidden" data-testid="welcome-banner">
      <div className="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-emerald-400/15 blur-2xl pointer-events-none" />
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center shrink-0">
          <PartyPopper className="w-6 h-6 text-emerald-100" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.2em] font-extrabold text-emerald-200">Account activated</div>
          <h3 className="mt-1 text-xl sm:text-2xl font-extrabold tracking-tighter font-[Outfit]">{msg}</h3>
          {promo && (
            <div className="mt-2 inline-flex items-center gap-2 bg-amber-300/20 border border-amber-200/40 rounded-full px-3 py-1 text-sm font-extrabold text-amber-100" data-testid="welcome-banner-promo">
              <span className="text-xs">PROMO</span>
              <span className="tracking-wider">{promo}</span>
              <span className="text-emerald-100/90 font-bold">· 10% OFF first service</span>
            </div>
          )}
        </div>
        <button onClick={close} aria-label="Dismiss" className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center" data-testid="welcome-banner-close">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
